import React from 'react';
import Cookies from 'universal-cookie';
import axios from 'axios';
import LocalStorage from 'Utils/localStorage';
import ProjectConfig from 'ProjectConfig';
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  RESET_LOGIN_FAILURE,
  LOGOUT_SUCCESS,
  REFRESH_TOKEN_SUCCESS,
  UPDATE_USER_BALANCE_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_BALANCE_SUCCESS,
  UPDATE_USER_AMOUNT_INFO_LIST_SUCCESS,
  UPDATE_USER_DIGITALGAMES_BALANCE_SUCCESS,
  UPDATE_USER_BALANCE_FAILURE,
  UPDATE_USER_DETAILS_SUCCESS,
  UPDATE_USER_DETAILS_FAILURE,
  USER_CONTRACT_ACCEPTED,
  GET_SEEN_ANNOUNCEMENT_COUNT_SUCCESS,
  ACCEPT_SCORE_WARNING,
  EMAIL_VERIFY_SUCCESS,
  CAPTCHA_REQUIRED,
  UPDATE_USER_BETSLIP_SETTINGS_SUCCESS,
  PREDEACTIVATED_STATUS_LOGIN_SUCCESS,
  DIGITAL_GAMES_POLICY_ACCEPTED,
  DIGITAL_GAMES_VALIDATE_TOKEN,
  PERSONALIZATION_POLICY_UPDATED,
  DIGITAL_GAMES_NEXT_GAME_REQUEST,
  DIGITAL_GAMES_NEXT_GAME_SUCCESS,
  DIGITAL_GAMES_NEXT_GAME_FAILURE,
  DIGITAL_GAMES_CREATE_SESSION,
  TOGGLE_SIDE_MENU,
  SEND_RATE_INFORMATION_REQUEST,
  SEND_RATE_INFORMATION_SUCCESS,
  SEND_RATE_INFORMATION_FAILURE,
  UPDATE_IS_EYE_OPEN,
  DISPLAY_EMAIL_OTP_ACTION_SHEET_IGNORED,
  DISPLAY_SMS_OTP_ACTION_SHEET_IGNORED,
  TRUSTED_DEVICE_ERROR,
  SET_OTP_INFO,
  SET_OTP_ERROR,
  RESET_OTP_ERROR,
  SEND_OTP_ERROR,
  SET_PENDING_MEMBERSHIP,
  CLEAR_PENDING_MEMBERSHIP
} from 'Store/constants';
import { checkCampaignJoinInfo, openModal, fetchPredictaBonusCampaign, closeModal } from 'Store/actions';
import {
  setAuthToken,
  removeAuthToken,
  hasAuthToken
} from 'Utils/authentication/setAxiosAuthHeader';
import { getWebviewModeFlag } from 'Utils/webviewMode';
import { isSuspendedMemberLogoutActive, shouldUseSuspendedLogoutOnForceAuthFailure, hasActiveAuthSession } from 'Utils/suspendedMemberLogout';
import EnvironmentManager from 'Utils/environmentManager';
import { getUrlParameter } from 'Utils/getUrlParameter';
import { trackLogin } from 'Utils/analytics';
import { trackLogout } from 'Utils/analytics';
import { getTribunUser } from './tribunActions';
import History from 'Store/history';
import { gameTypeMap } from '../../../utils/chanceGamesHelper';
import { setSentryUser, clearSentryUser } from 'Utils/sentry/setUserContext';
import { toast } from 'react-toastify';
import ToastTemplate from '../../components/ToastTemplate';
import mixpanel from 'Utils/mixpanel';

const API_GATEWAY = ProjectConfig.API_GATEWAY;
const ENV = process.env.NODE_ENV || 'development';

const cookieOptions = {
  path: '/',
  sameSite: ENV === 'production',
  secure: ENV === 'production'
};

const cookies = new Cookies();

const captchaCookieOptions = {
  path: '/',
  sameSite: ENV === 'production',
  secure: ENV === 'production',
  maxAge: 86400
};

export const loginUser = (formData, trackEvent = false, getLoginForm = false, usedReferenceCode) => async (dispatch, getState) => {
  dispatch({ type: LOGIN_REQUEST });


  try {

    const requestPayload = {
      ...formData,
      clientId: 'mobile.bilyoner.com',
    };

    if (usedReferenceCode) {
      requestPayload.referenceCode = usedReferenceCode;
    }

    const res = await axios({
      url: '/v2/oauth-manager/users/login',
      method: 'post',
      data: requestPayload
    });

    // Uygulama genelinde kullanılmak üzere axios headerlarını set ettiğimiz yer.
    const { accessToken } = res.data;
    setAuthToken(accessToken);

    if (trackEvent) {
      trackLogin({ login_type: null, user_id: res.data.externalCustomerId, user_balance: res.data?.balance });
    }
    //loginsiz girişte tribunUser ı set etmek için yapılmıştır. Yukarıdan giriş yapıldığı zaman user gelmiyordu.
    if (getLoginForm) {
      const tribunUser = getState().tribun?.tribunUser;
      const isTribunPath = History.location.pathname.includes('/tribun');
      if (!tribunUser?.userId && isTribunPath) {
        dispatch(getTribunUser());
      }
    }

    if (usedReferenceCode) {
      localStorage.setItem('loginWithReference', usedReferenceCode);
      localStorage.setItem('referencesPage', 'login');
    }

    if (res.data.externalCustomerId) {
      localStorage.setItem('externalCustomerId', res.data.externalCustomerId);
    }

    dispatch(fetchPredictaBonusCampaign());
    dispatch(loginSuccess(res.data));
    dispatch(updateUserBalance());

  } catch (error) {

    if (error?.response?.data?.extras?.captchaRequired) {
      cookies.set('captchaRequired', error?.response?.data?.extras?.captchaRequired, captchaCookieOptions);

      dispatch({
        type: CAPTCHA_REQUIRED
      });
    }


    const data = error?.response?.data;
    const cmsMessage = EnvironmentManager.getMessageText({ key: `${data?.domain}${data?.code}` });
    const suspended_ykn_login_message = EnvironmentManager.getMessageText({ key: 'suspended_ykn_login_message' });
    let errorText;

    if (data.code === 40324) {
      errorText = null;
    } else if (data.code === 40326) {
      errorText = suspended_ykn_login_message;
    } else if (error.response?.status >= 400 && error.response?.status <= 404) {
      errorText = cmsMessage || data?.message;
    } else {
      errorText = 'Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.';
    }

    if (error.response?.data?.code === 40319) {
      dispatch(openModal('changePasswordModal', {
        referenceCode: usedReferenceCode,
        identifier: formData?.username
      }));
    } else if (error.response?.data?.code === 40324) {
      dispatch(openModal('predeactivatedStatusLogin', { formData }));
    }

    dispatch(loginFailure(errorText));
    throw new Error(errorText);
  }
};

export const loginUserV2 = (formData, trackEvent = false, getLoginForm = false, usedReferenceCode) => async (dispatch, getState) => {
  dispatch({ type: LOGIN_REQUEST });

  try {
    const requestPayload = {
      ...formData,
      clientId: 'mobile.bilyoner.com',
    };

    if (usedReferenceCode) {
      requestPayload.referenceCode = usedReferenceCode;
    }

    // Turnstile token → request body "captcha" (backend LoginRequest.captcha)
    if (formData.captcha) {
      requestPayload.captcha = formData.captcha;
    }

    const res = await axios({
      url: '/v6/oauth-manager/users/login',
      method: 'post',
      data: requestPayload
    });
    // Uygulama genelinde kullanılmak üzere axios headerlarını set ettiğimiz yer.
    const { accessToken } = res.data;
    setAuthToken(accessToken);

    if (trackEvent) {
      trackLogin({ login_type: null, user_id: res.data.externalCustomerId, user_balance: res.data?.balance });
    }
    //loginsiz girişte tribunUser ı set etmek için yapılmıştır. Yukarıdan giriş yapıldığı zaman user gelmiyordu.
    if (getLoginForm) {
      const tribunUser = getState().tribun?.tribunUser;
      const isTribunPath = History.location.pathname.includes('/tribun');
      if (!tribunUser?.userId && isTribunPath) {
        dispatch(getTribunUser());
      }
    }

    if (usedReferenceCode) {
      localStorage.setItem('loginWithReference', usedReferenceCode);
      localStorage.setItem('referencesPage', 'login');
    }

    if (res.data.externalCustomerId) {
      localStorage.setItem('externalCustomerId', res.data.externalCustomerId);
    }

    dispatch(fetchPredictaBonusCampaign());
    dispatch(loginSuccess(res.data));
    dispatch(updateUserBalance());

  } catch (error) {

    if (error?.response?.data?.extras?.captchaRequired) {
      cookies.set('captchaRequired', error?.response?.data?.extras?.captchaRequired, captchaCookieOptions);

      dispatch({
        type: CAPTCHA_REQUIRED
      });
    }


    const data = error?.response?.data;
    const cmsMessage = EnvironmentManager.getMessageText({ key: `${data?.domain}${data?.code}` });
    const suspended_ykn_login_message = EnvironmentManager.getMessageText({ key: 'suspended_ykn_login_message' });
    let errorText;

    if (data.code === 40324) {
      errorText = null;
    } else if (data.code === 40326) {
      errorText = suspended_ykn_login_message;
    } else if (error.response?.status >= 400 && error.response?.status <= 404) {
      errorText = cmsMessage || data?.message;
    } else {
      errorText = 'Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.';
    }
    if (error.response?.data?.code === 40319) {
      dispatch(openModal('changePasswordModal', {
        referenceCode: usedReferenceCode,
        identifier: formData?.username
      }));
    } else if (error.response?.data?.code === 40324) {
      dispatch(openModal('predeactivatedStatusLogin', { formData }));
    } else if (error.response?.data?.code === 87000) {
      dispatch({
        type: TRUSTED_DEVICE_ERROR,
        payload: error.response?.data?.extras
      });
      dispatch(openModal('trustedDeviceModal', { error: error.response?.data?.extras || null }));
    } else if ( error.response?.data?.code === 4073) {
      dispatch({
        type: SEND_OTP_ERROR,
        payload: error.response?.data?.message
      });
      dispatch(openModal('errorTrustedDeviceModal'));
    } else if (error.response?.data?.code === 88000) {
      const extras = error.response?.data?.extras;

      if (extras?.isNew === null || extras?.isNew === undefined) {
        dispatch(loginFailure(errorText));
        throw new Error(errorText);
      }

      const remainingTimeMillis = extras?.remainingTimeMillis;

      if (remainingTimeMillis === 0) {
        dispatch(loginFailure(errorText));
        throw new Error(errorText);
      }

      const remainingTimeInSeconds = remainingTimeMillis === -1
        ? -1
        : Math.floor(remainingTimeMillis / 1000);
      const storedAt = Date.now();

      localStorage.removeItem('loginWithReference');
      localStorage.removeItem('referencesPage');

      const pendingMembershipPayload = {
        isNew: extras?.isNew,
        referenceNumber: extras?.referenceId,
        remainingTimeInSeconds,
        storedAt
      };

      localStorage.setItem('pendingMembership', JSON.stringify(pendingMembershipPayload));

      mixpanel.track('Complete Login', {
        'Last Login Time': new Date().toISOString(),
        'User Status': 'Pending',
      });

      dispatch({
        type: SET_PENDING_MEMBERSHIP,
        payload: pendingMembershipPayload
      });

      History.push('/pending-activation');
      return;
    } else if (error.response?.data?.code === 88001) {
      dispatch(loginFailure(errorText));
      throw new Error(errorText);
    } else if (error.response?.data?.code === 88002) {
      dispatch(loginFailure(errorText));
      throw new Error(errorText);
    }

    dispatch(loginFailure(errorText));
    throw new Error(errorText);
  }
};

export const sendOtpTrustedDevice = otpData => async dispatch => {
  try {
    const res = await axios({
      url: '/users/trusted-devices/send-otp',
      method: 'post',
      data: otpData
    });
    
    dispatch({
      type: SET_OTP_INFO,
      payload: res?.data
    });
  } catch (err) {
    dispatch({
      type: SEND_OTP_ERROR,
      payload: err.response?.data?.message
    });
    dispatch(openModal('errorTrustedDeviceModal'));
    throw new Error(err.response?.data?.message);
  }
};

export const loginWithOtpModal = (data, getLoginForm = false) => async (dispatch, getState) => {
  
  try {
    const res = await axios({
      url: '/v6/oauth-manager/users/login/with-otp',
      method: 'post',
      data: data
    });

    // Uygulama genelinde kullanılmak üzere axios headerlarını set ettiğimiz yer.
    const { accessToken } = res.data;
    setAuthToken(accessToken);

    // if (trackEvent) {
    //   trackLogin({ login_type: null, user_id: res.data.externalCustomerId, user_balance: res.data?.balance });
    // }
    // loginsiz girişte tribunUser ı set etmek için yapılmıştır. Yukarıdan giriş yapıldığı zaman user gelmiyordu.
    if (getLoginForm) {
      const tribunUser = getState().tribun?.tribunUser;
      const isTribunPath = History.location.pathname.includes('/tribun');
      if (!tribunUser?.userId && isTribunPath) {
        dispatch(getTribunUser());
      }
    }


    if (res.data.externalCustomerId) {
      localStorage.setItem('externalCustomerId', res.data.externalCustomerId);
    }

    dispatch(fetchPredictaBonusCampaign());
    dispatch(loginSuccess(res.data));
    dispatch(updateUserBalance());
   
    if (data?.otpType === 'SMS') {
      dispatch(closeModal('loginWithSmsOtpModal'));
    } else {
      dispatch(closeModal('loginWithEmailOtpModal'));
    }
    dispatch(openModal('succesLoginWithOtp'));
  } catch (error) {
    const data = error?.response?.data;
    const cmsMessage = EnvironmentManager.getMessageText({ key: `${data?.domain}${data?.code}` });
    const suspended_ykn_login_message = EnvironmentManager.getMessageText({ key: 'suspended_ykn_login_message' });
    let errorText;

    if (data.code === 40324) {
      errorText = null;
    } else if (data.code === 40326) {
      errorText = suspended_ykn_login_message;
    } else if (error.response?.status >= 400 && error.response?.status <= 404) {
      errorText = cmsMessage || data?.message;
    } else {
      errorText = 'Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.';
    }

    if (error.response?.data?.code === 4022 || error.response?.data?.code === 4020) {
      dispatch({
        type: SET_OTP_ERROR,
        payload: error.response?.data?.message,
      });
    } else if (error.response?.data?.code === 88000) {
      const extras = error.response?.data?.extras;

      if (extras?.isNew === null || extras?.isNew === undefined) {
        dispatch(loginFailure(errorText));
        throw new Error(errorText);
      }

      const remainingTimeMillis = extras?.remainingTimeMillis;

      if (remainingTimeMillis === 0) {
        dispatch(loginFailure(errorText));
        throw new Error(errorText);
      }

      const remainingTimeInSeconds = remainingTimeMillis === -1
        ? -1
        : Math.floor(remainingTimeMillis / 1000);
      const storedAt = Date.now();

      localStorage.removeItem('loginWithReference');
      localStorage.removeItem('referencesPage');

      const pendingMembershipPayload = {
        isNew: extras?.isNew,
        referenceNumber: extras?.referenceId,
        remainingTimeInSeconds,
        storedAt
      };

      localStorage.setItem('pendingMembership', JSON.stringify(pendingMembershipPayload));

      mixpanel.track('Complete Login', {
        'Last Login Time': new Date().toISOString(),
        'User Status': 'Pending',
      });

      dispatch({
        type: SET_PENDING_MEMBERSHIP,
        payload: pendingMembershipPayload
      });

      History.push('/pending-activation');
      return;
    } else if (error.response?.data?.code === 88001) {
      dispatch(loginFailure(errorText));
      throw new Error(errorText);
    } else if (error.response?.data?.code === 88002) {
      dispatch(loginFailure(errorText));
      throw new Error(errorText);
    }

    dispatch(loginFailure(errorText));
    throw new Error(errorText);
  }
};

export const resetOtpError = () => {
  return {
    type: RESET_OTP_ERROR,
  };
};

export const loginWithCaptcha = (formData, trackEvent = false, usedReferenceCode) => async dispatch => {
  dispatch({ type: LOGIN_REQUEST });

  try {
    const res = await axios({
      url: '/v3/oauth-manager/users/login/with-captcha',
      method: 'post',
      data: {
        ...formData,
        clientId: 'mobile.bilyoner.com',
        referenceCode: usedReferenceCode
      }
    });

    // Uygulama genelinde kullanılmak üzere axios headerlarını set ettiğimiz yer.
    const { accessToken } = res.data;

    setAuthToken(accessToken);
    cookies.remove('captchaRequired', { path: captchaCookieOptions.path });

    if (trackEvent) {
      trackLogin({ login_type: null, user_id: res.data.externalCustomerId, user_balance: res.data?.balance });
    }

    if (usedReferenceCode) {
      localStorage.setItem('loginWithReference', usedReferenceCode);
      localStorage.setItem('referencesPage', 'login');
    }
    dispatch(loginSuccess(res.data));
  } catch (error) {

    if (error?.response?.data?.extras?.captchaRequired) {
      cookies.set('captchaRequired', error?.response?.data?.extras?.captchaRequired, captchaCookieOptions);

      dispatch({
        type: CAPTCHA_REQUIRED
      });
    }

    const data = error?.response?.data;
    const cmsMessage = EnvironmentManager.getMessageText({ key: `${data?.domain}${data?.code}` });

    const errorText
      = error.response?.status >= 400 && error.response?.status <= 404
        ? cmsMessage || data?.message
        : 'Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.';

    if (error.response?.data?.code === 40319) {
      dispatch(openModal('changePasswordModal', {
        referenceCode: usedReferenceCode,
        identifier: formData?.username
      }));
    } else if (error.response?.data?.code === 88000) {
      const extras = error.response?.data?.extras;

      if (extras?.isNew === null || extras?.isNew === undefined) {
        dispatch(loginFailure(errorText));
        throw new Error(errorText);
      }

      const remainingTimeMillis = extras?.remainingTimeMillis;

      if (remainingTimeMillis === 0) {
        dispatch(loginFailure(errorText));
        throw new Error(errorText);
      }

      const remainingTimeInSeconds = remainingTimeMillis === -1
        ? -1
        : Math.floor(remainingTimeMillis / 1000);
      const storedAt = Date.now();

      localStorage.removeItem('loginWithReference');
      localStorage.removeItem('referencesPage');

      const pendingMembershipPayload = {
        isNew: extras?.isNew,
        referenceNumber: extras?.referenceId,
        remainingTimeInSeconds,
        storedAt
      };

      localStorage.setItem('pendingMembership', JSON.stringify(pendingMembershipPayload));

      mixpanel.track('Complete Login', {
        'Last Login Time': new Date().toISOString(),
        'User Status': 'Pending',
      });

      dispatch({
        type: SET_PENDING_MEMBERSHIP,
        payload: pendingMembershipPayload
      });

      History.push('/pending-activation');
      return;
    } else if (error.response?.data?.code === 88001) {
      dispatch(loginFailure(errorText));
      throw new Error(errorText);
    } else if (error.response?.data?.code === 88002) {
      dispatch(loginFailure(errorText));
      throw new Error(errorText);
    }

    dispatch(loginFailure(errorText));
    throw new Error(errorText);
  }
};

export const refreshToken = () => async (dispatch, getState) => {
  try {
    const { refreshToken, userId } = getState().auth.data;
    const res = await axios({
      url: '/v2/oauth-manager/users/login/refresh',
      method: 'put',
      data: {
        token: refreshToken,
        username: userId?.toString(),
      }
    });

    const { accessToken } = res.data;

    setAuthToken(accessToken);
    dispatch(refreshTokenSuccess(res.data));

    return res.data;

  } catch (error) {
    if (!getWebviewModeFlag()) {
      if (isSuspendedMemberLogoutActive() || shouldUseSuspendedLogoutOnForceAuthFailure(getState().auth)) {
        throw error;
      }
      removeAuthToken();
      cookies.remove('user', { path: cookieOptions.path });
      dispatch(logoutUser());
    }
    throw error;
  }
};
// TODO: details requestini App.js contstructor props.updateUserDetails(); methodu atiyor, hangisi gereksiz ise ona gore silinmeli
const loginWithAccessToken = ({ accessToken, refreshToken }) => async dispatch => {
  let user = {};
  if (accessToken) {
    user.accessToken = accessToken;
    user.refreshToken = refreshToken;

    await axios.get('/user-settings?full=true').then(response => {

      if (response) {
        dispatch(loginSuccess(user));
      } else {
        dispatch(loginWithRefreshToken(refreshToken, true));
      }
    });
  }
};


let _loginWithRefreshTokenInFlight = false;

export const loginWithRefreshToken = refreshToken => async (dispatch, getState) => {
  // Guard: skip if already authenticated (prevents duplicate calls from App + RequireAuth)
  if (getState().auth.isAuthenticated === true) return;
  // Guard: skip if another refresh is already in flight (prevents race condition)
  if (_loginWithRefreshTokenInFlight) return;
  _loginWithRefreshTokenInFlight = true;

  dispatch({ type: LOGIN_REQUEST });

  const accessToken = getUrlParameter('accessToken');

  if (accessToken) {
    try {
      return await dispatch(loginWithAccessToken({ accessToken, refreshToken }));
    } finally {
      _loginWithRefreshTokenInFlight = false;
    }
  }

  const userId = getState().auth?.data?.userId;

  try {
    let user = {};

    const accessTokenRes = await axios({
      url: '/v2/oauth-manager/users/login/refresh',
      method: 'put',
      data: {
        token: refreshToken,
        username: userId?.toString(),
      },
    });

    user.accessToken = accessTokenRes.data.accessToken;
    user.accessTokenExpireDate = accessTokenRes.data.accessTokenExpireDate;
    user.refreshToken = refreshToken;

    const { accessToken } = accessTokenRes.data;
    setAuthToken(accessToken);

    dispatch(loginSuccess(user));

  } catch (error) {
    if (!getWebviewModeFlag()) {
      if (!(isSuspendedMemberLogoutActive() || shouldUseSuspendedLogoutOnForceAuthFailure(getState().auth))) {
        dispatch(logoutUser());
      }
    }
  } finally {
    _loginWithRefreshTokenInFlight = false;
  }
};

export const logoutUser = () => async (dispatch, getState) => {
  if (isSuspendedMemberLogoutActive()) {
    return;
  }

  removeAuthToken();
  cookies.remove('user', { path: cookieOptions.path });
  const { accessToken, userId } = getState().auth.data;
  dispatch(logoutUserSuccess());

  try {
    await axios({
      url: '/v2/oauth-manager/users/logout',
      data: {
        token: accessToken,
        username: userId?.toString(),
      },
      method: 'post'
    });

    LocalStorage.remove('sortOptions');
    LocalStorage.remove('filterOptions');
    LocalStorage.remove('externalCustomerId');
  } catch (error) {
    // no-op
  }

};

export const logoutUserLocally = () => dispatch => {
  if (isSuspendedMemberLogoutActive()) {
    return;
  }
  removeAuthToken();
  cookies.remove('user', { path: cookieOptions.path });
  LocalStorage.remove('sortOptions');
  LocalStorage.remove('filterOptions');
  LocalStorage.remove('externalCustomerId');
  dispatch(logoutUserSuccess());
};

export const updateUserDetails = (fullSettings = false, user) => async (dispatch, getState) => {
  if (!hasActiveAuthSession(getState().auth) || !hasAuthToken() || isSuspendedMemberLogoutActive()) {
    return;
  }

  try {
    dispatch({ type: LOGIN_REQUEST });

    const res = await axios.get('/user-settings', {
      params: { full: fullSettings }
    });
    const newUserDetails = res.data;

    if (res.data?.externalCustomerId) {
      localStorage.setItem('externalCustomerId', res.data.externalCustomerId);
    }

    dispatch({
      type: UPDATE_USER_DETAILS_SUCCESS,
      payload: newUserDetails
    });

    dispatch({
      type: GET_SEEN_ANNOUNCEMENT_COUNT_SUCCESS,
      payload: newUserDetails.unSeenAnnouncementsCount
    });


    if (user?.showFirstPaymentPopUp) {
      const firstPaymentMessage = EnvironmentManager.getMessageText({ key: 'pending_membership_activation_toast_message' }) || 'Tebrikler. Üyeliğin başarıyla aktif edildi.';
      toast(
        <ToastTemplate type="success">
          { firstPaymentMessage }
        </ToastTemplate>,
        {
          toastId: 'first-payment-success',
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        }
      );

      // Track: View Registration Activated Success Message
      mixpanel.track('View Registration Activated Success Message');
    }

  } catch (e) {
    dispatch({
      type: UPDATE_USER_DETAILS_FAILURE
    });
  }
};

export const updateUserDetailsKvkkForm = (fullSettings = false) => async dispatch => {
  try {

    const res = await axios.get('/user-settings', {
      params: { full: fullSettings }
    });
    const newUserDetails = res.data;

    dispatch({
      type: UPDATE_USER_DETAILS_SUCCESS,
      payload: newUserDetails
    });

  } catch (e) {
    dispatch({
      type: UPDATE_USER_DETAILS_FAILURE
    });
  }
};

export const updateUserBalance = () => async dispatch => {
  try {
    dispatch({
      type: UPDATE_USER_BALANCE_REQUEST
    });

    // In order to set content type header, body must exists.
    const res = await axios.get('/account-balance', {
      data: {},
      headers: {
        'Content-Type': 'application/json'
      }
    });

    dispatch(applyUserBalancePayload(res.data, 'rest-account-balance'));

    return res.data;
  } catch (e) {
    dispatch({
      type: UPDATE_USER_BALANCE_FAILURE
    });
    return null;
  }
};

export const applyUserBalancePayload = (payload, source = 'unknown') => dispatch => {
  const { balance, amountInfoList, digitalGamesBalance } = payload || {};

  dispatch({
    type: UPDATE_USER_SUCCESS,
    payload: payload?.availableTopWinPoint
  });

  dispatch({
    type: UPDATE_USER_BALANCE_SUCCESS,
    payload: balance
  });

  dispatch({
    type: UPDATE_USER_AMOUNT_INFO_LIST_SUCCESS,
    payload: amountInfoList
  });

  dispatch({
    type: UPDATE_USER_DIGITALGAMES_BALANCE_SUCCESS,
    payload: digitalGamesBalance
  });
};

export const acceptUserContract = () => async dispatch => {
  try {
    await axios.post('/users/accepted-contracts');

    dispatch({
      type: USER_CONTRACT_ACCEPTED
    });

  } catch (e) {
    //console.log('error while accepting contract', e);
  }
};

export const loginSuccess = user => async dispatch => {

  dispatch({
    type: LOGIN_SUCCESS,
    payload: user
  });

  setSentryUser({
    id: user?.externalCustomerId || user?.userId,
    username: user?.username || user?.name,
    email: user?.email,
    segment: user?.segment,
    isVip: user?.isVip
  });

  const isCampaignActive = EnvironmentManager.getParameter('campaign_info_visible');

  if (isCampaignActive) {
    const campaignId = EnvironmentManager.getParameter('active_withdraw_campaignId');

    dispatch(checkCampaignJoinInfo(campaignId));
  }
  dispatch(updateUserDetails(true, user));
};

export const acceptScoreWarning = () => async dispatch => {
  try {
    await axios.post('/user-settings/confirmation', { key: 'bilgilendirici_text_message' });

    dispatch({
      type: ACCEPT_SCORE_WARNING
    });
  } catch (err) {
    //console.log('Error occurred while accepting score warning.');
  }
};

const loginFailure = error => {
  return {
    type: LOGIN_FAILURE,
    payload: error
  };
};

export const resetLoginFailure = () => {
  return {
    type: RESET_LOGIN_FAILURE,
    payload: null
  };
};

export const logoutUserSuccess = () => {
  trackLogout();
  clearSentryUser();
  return {
    type: LOGOUT_SUCCESS
  };
};

const refreshTokenSuccess = refreshToken => {
  return {
    type: REFRESH_TOKEN_SUCCESS,
    payload: refreshToken
  };
};

export const sendVerificationEmail = () => async () => {
  try {
    return await axios({
      url: '/users/send/email-code',
      method: 'post',
    });
  } catch (err) {
    throw err;
  }
};

export const verifyEmail = token => async dispatch => {
  try {
    const data = await axios({
      url: '/users/verify/email-code',
      method: 'post',
      data: {
        verifyCode: token,
      }
    });

    dispatch({ type: EMAIL_VERIFY_SUCCESS });

    return data;
  } catch (err) {
    throw {
      code: err?.response?.data?.code,
      message: err?.response?.data?.message,
    };
  }
};

export const updateUserBetSlipSettings = settings => async dispatch => {
  try {
    await axios.put(API_GATEWAY + '/user-settings/confirmation/odd-change', settings);
    dispatch({
      type: UPDATE_USER_BETSLIP_SETTINGS_SUCCESS,
      payload: settings,
    });

    await dispatch(updateUserDetails());
  } catch (err) {
    throw err;
  }
};


export const predeactivatedStatusLogin = (username, password) => async dispatch => {
  try {
    const data = await axios({
      url: '/users/status/cancel/request/via/login',
      method: 'post',
      data: {
        username,
        password,
        birthDate: {
          day: null,
          month: null,
          year: null
        },
      }
    });

    dispatch({ type: PREDEACTIVATED_STATUS_LOGIN_SUCCESS });

    return data;
  } catch (err) {
    throw {
      code: err?.response?.data?.code,
      message: err?.response?.data?.message,
    };
  }
};

export const acceptDigitalGamesPolicy = () => async dispatch => {
  try {
    await axios.post('/user-settings/confirmation/digital-games/policy');

    dispatch({
      type: DIGITAL_GAMES_POLICY_ACCEPTED
    });

  } catch (e) {
    //console.log('error while accepting digital games policy', e);
  }
};

export const validateTokenDigitalGames = accessToken => async dispatch => {
  try {
    const res = await axios({
      url: '/digital-games/token/validate',
      data: {
        xauthToken: accessToken,
      },
      method: 'post'
    });

    dispatch({
      type: DIGITAL_GAMES_VALIDATE_TOKEN
    });

    return res?.data;

  } catch (e) {
    //console.log('error while accepting digital games validate token', e);
  }
};

export const createSessionDigitalGames = (accessToken, externalCustomerId) => async dispatch => {
  try {
    const res = await axios.post('/digital-games/token', { externalCustomerId: externalCustomerId, xauthToken: accessToken });
    dispatch({
      type: DIGITAL_GAMES_CREATE_SESSION,
      payload: res?.data?.body?.sessionId
    });
  } catch (e) {
    console.log('error while create a session', e);
  }
};
function findKeyByValue (obj, value) {
  return Object.keys(obj).find(key => obj[key] === value) || null;
}
export const createSessionSomosGames = (accessToken, externalCustomerId, gameType) => async dispatch => {
  try {
    const key = findKeyByValue(gameTypeMap, gameType);
    const res = await axios.post('/digital-games/token', { externalCustomerId: externalCustomerId, xauthToken: accessToken, gameType: key });

    dispatch({
      type: DIGITAL_GAMES_CREATE_SESSION,
      payload: res?.data?.body?.sessionId
    });
  } catch (e) {
    console.log('error while create a session', e);
  }
};

export const updatePersonalizationPolicyAnswer = (answer, cb) => async dispatch => {
  try {
    await axios({
      url: '/user-settings/confirmation/personalization/policy',
      data: {
        acceptance: answer,
      },
      method: 'post'
    });
    dispatch({
      type: PERSONALIZATION_POLICY_UPDATED,
      payload: { answer, isError: false }
    });

    if (cb) {
      cb(true);
    }
  } catch (e) {
    if (cb) {
      cb(false);
    }
    dispatch({
      type: PERSONALIZATION_POLICY_UPDATED,
      payload: { answer, isError: true }
    });

    console.log('error while updatePersonalizationPolicyAnswer', e);
  }
};

export const nextGameOfDigitalGames = gameType => async dispatch => {
  try {
    dispatch({
      type: DIGITAL_GAMES_NEXT_GAME_REQUEST
    });
    const res = await axios.get(`/bingo/next-game/${gameType}`);

    dispatch({
      type: DIGITAL_GAMES_NEXT_GAME_SUCCESS,
      payload: res.data
    });

    return res;

  } catch (e) {

    dispatch({
      type: DIGITAL_GAMES_NEXT_GAME_FAILURE,
      payload: e.response && e.response.data
    });
  }
};

export const toggleSideMenu = payload => dispatch => {
  dispatch({
    type: TOGGLE_SIDE_MENU,
    payload: payload
  });
};

export const updateIsEyeOpenCheck = isEyeOpen => async dispatch => {
  try {
    dispatch({
      type: UPDATE_IS_EYE_OPEN,
      payload: isEyeOpen
    });
    LocalStorage.set('eyeOpen', isEyeOpen);

  } catch (err) {
    throw err;
  }
};

export const sendRateInformation = rate => async (dispatch, getState) => {
  try {
    dispatch({
      type: SEND_RATE_INFORMATION_REQUEST
    });

    const res = await axios({
      url: '/user-settings/confirmation/rate-information',
      method: 'POST',
      data: {
        rate: rate,
      }
    });

    dispatch({
      type: SEND_RATE_INFORMATION_SUCCESS,
      payload: res.data
    });
    return res;
  } catch (e) {
    dispatch({
      type: SEND_RATE_INFORMATION_FAILURE,
      payload: e.response && e.response.data,
    });
  }
};


export const ignoreEmailVerification = () => async dispatch => {
  try {

    await axios({
      url: `${API_GATEWAY}/users/otp-action-sheet/ignore`,
      method: 'PUT',
      data: {
        type: 'EMAIL'
      },
    });
    const oldUserCookie = cookies.get('user');

    cookies.set('user', { ...oldUserCookie, displayEmailOtpActionSheet: false }, cookieOptions);

    dispatch({
      type: DISPLAY_EMAIL_OTP_ACTION_SHEET_IGNORED
    });

  } catch (e) {
    //console.log('error while accepting contract', e);
  }
};

export const ignoreSmsVerification = () => async dispatch => {
  try {

    await axios({
      url: `${API_GATEWAY}/users/otp-action-sheet/ignore`,
      method: 'PUT',
      data: {
        type: 'SMS'
      },
    });

    const oldUserCookie = cookies.get('user');

    cookies.set('user', { ...oldUserCookie, displaySmsOtpActionSheet: false }, cookieOptions);

    dispatch({
      type: DISPLAY_SMS_OTP_ACTION_SHEET_IGNORED
    });

  } catch (e) {
    //console.log('error while accepting contract', e);
  }
};

export const clearPendingMembership = () => {
  localStorage.removeItem('pendingMembership');
  return {
    type: CLEAR_PENDING_MEMBERSHIP
  };
};
